
export default {
name: "PlanSwitcherPointer",
props: {
  fill: {
    default: '#727CF5'
  }
}
}
